import { useState, type FormEvent } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useCreateCustomer } from "@/api/mutations/customers";

// Kunde registrieren (name + email). Email-Format validiert die Domain final.
export function CreateCustomerDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const create = useCreateCustomer();

  function submit(e: FormEvent) {
    e.preventDefault();
    create.mutate(
      { name: name.trim(), email: email.trim() },
      {
        onSuccess: () => {
          setName("");
          setEmail("");
          onOpenChange(false);
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-customer-dialog">
        <DialogHeader>
          <DialogTitle>Kunde anlegen</DialogTitle>
          <DialogDescription>Registriert einen neuen Kunden im Portal.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="cust-name">Name</Label>
            <Input id="cust-name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="customer-name" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cust-email">Email</Label>
            <Input id="cust-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="customer-email" />
          </div>
          {create.isError && (
            <div className="text-sm text-danger" data-testid="create-customer-error">
              {create.error.message}
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={create.isPending}>
              Abbrechen
            </Button>
            <Button type="submit" disabled={create.isPending} data-testid="create-customer-submit">
              {create.isPending ? "…" : "Anlegen"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
